<template>
  <div v-if="hasAnyPermission('role-view')" class="py-4 container-fluid">
    <ToastPrime position="bottom-left"/>
    <div class="card">
      <div class="card-header py-3">
        <div class="row align-items-center">
          <div class="col-4">
            <h5 class="mb-0">Role Management</h5>
          </div>
          <div class="col-4 d-flex justify-content-center">
            <IconField class="w-100">
              <InputIcon>
                <i class="pi pi-search"></i>
              </InputIcon>
              <InputText
                v-model="table.search"
                type="text"
                size="small"
                placeholder="Search"
                class="rounded-pill w-100"
                @keyup="filter"
              />
            </IconField>
          </div>
          <div class="col-4 d-flex justify-content-end">
             <button
              v-if="hasAnyPermission('role-create')"
              type="button"
              class="mx-1 mb-0 btn btn-sm btn-primary"
              @click="$router.push({ name: 'Manage Role Create', params: { moduleSlug: 'material-management', action: 'create' } })"
            >
              Add
            </button>
          </div>
        </div>
      </div>
      <!-- <DialogPrime v-model:visible="showAddDialog" modal header="Add Role" :style="{ width: '800px' }">
        <form @submit.prevent="submitAddRole">
          <div class="mb-3">
            <label class="form-label">Name<span class="text-danger">*</span></label>
            <InputText 
              v-model="addForm.name" 
              class="w-100" 
              :class="`${(addErrorMessage['name'] && addForm.name == '') ? 'border-danger' : ''}`" 
              placeholder="Enter Role Name" 
              required 
            />
            <small v-if="addErrorMessage['name'] && addForm.name == ''" class="text-danger">{{ addErrorMessage['name'] }}</small>
          </div>
          <div class="mb-3">
            <label class="form-label">Guard Name<span class="text-danger">*</span></label>
            <Dropdown 
              v-model="addForm.guard_name" 
              :options="guardOptions" 
              optionLabel="label" 
              optionValue="value" 
              class="w-100" 
              :class="`${(addErrorMessage['guard_name'] && addForm.guard_name == '') ? 'border-danger' : ''}`" 
              placeholder="Select Guard Name" 
              required 
            />
            <small v-if="addErrorMessage['guard_name'] && addForm.guard_name == ''" class="text-danger">{{ addErrorMessage['guard_name'] }}</small>
          </div>
          <div class="mb-3">
            <label class="form-label">Permissions<span class="text-danger">*</span></label>
            <MultiSelect 
              v-model="addForm.permissions" 
              :options="permissionOptions" 
              optionLabel="label" 
              optionValue="value" 
              class="w-100" 
              :class="`${(addErrorMessage['permissions'] && addForm.permissions.length == 0) ? 'border-danger' : ''}`" 
              placeholder="Select Permissions" 
              display="chip" 
              required 
              filter 
            />
            <small v-if="addErrorMessage['permissions'] && addForm.permissions.length == 0" class="text-danger">{{ addErrorMessage['permissions'] }}</small>
          </div>
          <div class="d-flex justify-content-end">
            <ButtonPrime label="Cancel" class="p-button-text me-2" @click="closeAddModal" type="button" />
            <ButtonPrime label="Save" icon="pi pi-check" type="submit" :loading="addLoading" />
          </div>
        </form>
      </DialogPrime> -->

      <div style="height: 500px; overflow-y: auto;">
        <DataTable
          :value="table.onLoad ? dummyRows : table.filteredData"
          removable-sort
          scrollable
          scroll-height="flex"
          table-style="min-width: 50rem"
        >
          <Column field="name" header="Name" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.name ? slotProps.data.name : '' }}
            </template>
          </Column>
          <Column field="created_at" header="Created At" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.created_at ? formatDate(slotProps.data.created_at) : '' }}
            </template>
          </Column>
          <Column field="updated_at" header="Updated At" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.updated_at ? formatDate(slotProps.data.updated_at) : '' }}
            </template>
          </Column>
          <Column header="Actions" header-class="bg-light" :style="{ width: '150px' }" :body-style="{ width: '150px', padding: '0' }">
            <template v-if="table.onLoad" #body>
              <Skeleton />
            </template>
          <template v-else #body="slotProps">
            <ButtonPrime v-if="hasAnyPermission('role-update')" v-tooltip.bottom="'Update'" icon="pi pi-pencil" outlined rounded size="small" class="me-2" @click="$router.push({ name: 'Manage Role Edit', params: { moduleSlug: 'material-management', dataRoleCode: slotProps.data.id, action: 'edit' } })"/>
            <ButtonPrime v-if="hasAnyPermission('role-delete')" v-tooltip.bottom="'Delete'" icon="pi pi-trash" outlined rounded severity="danger" size="small" @click="confirmDelete(slotProps.data)"/>
          </template>
        </Column>
          <template #empty>
            <div style="text-align: center; padding: 40px 0;">
              <img src="/no_data.png" alt="No Data" style="max-width: 330px; opacity: 0.7; margin-bottom: 0;" />
              <div style="color: #888; font-size: 1.1em; font-weight: 500;">
                No Data
              </div>
            </div>
          </template>
        </DataTable>
      </div>
      <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
        <BasePagination
          v-model="table.page.current_pages"
          :page-count="table.page.total_pages || 1"
          size="sm"
          @click="changePage()"
        />
        <p>
          {{ (table.page.current_pages - 1) * table.page.per_pages + (table.filteredData ? table.filteredData.length : 0) }} of {{ table.total }}
        </p>
      </div>
    </div>
  </div>
  <NoAccess v-else />
</template>

<script>
import { mapState } from "vuex";
import BasePagination from "@/components/BasePagination.vue";
import ToastPrime from 'primevue/toast';
import moment from "moment";
import api from "@/helpers/api";
import manageRoleService from "@/services/manageAccount/manageRoleService";
import managePermissionService from "@/services/manageAccount/managePermissionService";
import NoAccess from "@/components/NoAccess.vue";

export default {
  components: { BasePagination, ToastPrime, NoAccess },
  computed: {
    ...mapState({
      authUserPermissions: (state) => state.auth.userHasPermissions || [],
    }),
  },
  data() {
    return {
      table: {
        onLoad: true,
        search: this.$route.query.search || "",
        total: 0,
        data: [],
        filteredData: [],
        limit: 10,
        page: {
          current_pages: 1,
          per_pages: 10,
          total_pages: 1,
        },
        loadTimeout: null,
      },
      dummyRows: Array.from({ length: 10 }, () => ({})),
      showAddDialog: false,
      addForm: {
        name: '',
        guard_name: '',
        permissions: []
      },
      addErrorMessage: {},
      addLoading: false,
      guardOptions: [
        { label: 'API', value: 'api' },
        { label: 'Web', value: 'web' }
      ],
      permissionOptions: [],
      showDeleteDialog: false,
      deleteLoading: false,
      roleToDelete: null,
      roleToEdit: null,
    };
  },
  mounted() {
    if (this.hasAnyPermission('role-view')) {
      this.get();
    }
    if (this.hasAnyPermission('permission-view')) {
      this.loadPermissions();
    }
  },
  methods: {
    hasAnyPermission(...perms) {
      return perms.some((p) => this.authUserPermissions.includes(p));
    },
    async get() {
      this.table.onLoad = true;
      try {
        const params = {
          search: this.table.search,
          limit: this.table.limit,
          page: this.table.page.current_pages,
        };
        const paginated = await api(this, manageRoleService.list(params), false);
        this.table.data = paginated.data.data || [];
        this.table.total = paginated.data.total || 0;
        this.table.page.total_pages = paginated.data.last_page || 1;
        this.table.page.per_pages = paginated.data.per_page || this.table.limit;
        this.applyFilter();
      } catch (error) {
        this.table.data = [];
        this.table.filteredData = [];
        this.table.total = 0;
        this.table.page.total_pages = 1;
      } finally {
        this.table.onLoad = false;
      }
    },
    async loadPermissions() {
      try {
        const response = await api(this, managePermissionService.listAll(), false);
        const allData = response.data || [];
        this.permissionOptions = allData.map(item => ({ label: item.name, value: item.name }));
      } catch (e) {
        this.permissionOptions = [];
      }
    },
    // async submitAddRole() {
    //   this.addErrorMessage = {};
    //   if (!this.addForm.name) this.addErrorMessage['name'] = 'Name required';
    //   if (!this.addForm.guard_name) this.addErrorMessage['guard_name'] = 'Guard Name required';
    //   if (this.addForm.permissions.length === 0) this.addErrorMessage['permissions'] = 'Permissions required';
    //   if (Object.keys(this.addErrorMessage).length > 0) return;

    //   this.addLoading = true;
    //   try {
    //     const payload = {
    //       name: this.addForm.name,
    //       guard_name: this.addForm.guard_name,
    //       permissions: this.addForm.permissions
    //     };
    //     await api(this, manageRoleService.create(payload), true);
    //     this.closeAddModal();
    //     this.get();
    //   } catch (error) {
    //     if (error.response?.data?.code == 400 && error.response.data.data) {
    //       error.response.data.data.forEach((v) => {
    //         this.addErrorMessage[v.path] = v.msg;
    //       });
    //     } else {
    //       console.error('Error saving role:', error);
    //     }
    //   } finally {
    //     this.addLoading = false;
    //   }
    // },


    applyFilter() {
      this.table.filteredData = this.table.data;
    },
    filter() {
      clearTimeout(this.table.loadTimeout);
      this.table.loadTimeout = setTimeout(() => {
        this.$router.push({ query: this.table.search ? { search: this.table.search } : null });
        this.table.page.current_pages = 1;
        this.get();
      }, 500);
    },
    changePage() {
      this.get();
    },
    closeAddModal() {
      this.showAddDialog = false;
      this.addForm = { name: '', guard_name: '', permissions: [] };
      this.addErrorMessage = {};
      this.addLoading = false;
    },

    formatDate(date) {
      return date ? moment(date).format("DD MMMM YYYY, HH:mm") : "-";
    },
    confirmDelete(role) {
      this.confirmDialog("You won't be able to revert this!","delete it").then((result) => {
        if (result.isConfirmed) {
          this.deleteLoading = true;
          api(this, manageRoleService.delete(role.id)).then(() => {
            this.get();
          }).finally(() => {
            this.deleteLoading = false;
          });
        }
      });
    },
  },
};
</script>